import { useState } from 'react';
import { EllipsisVertical, Pencil, Trash } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { TableCell, TableRow } from '@/components/ui/table';

import DeleteFeeDialog from './DeleteFeeDialog';
import EditFeeDialog from './EditFeeDialog';

const FeeRow = ({ fee }) => {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  return (
    <>
      <TableRow>
        <TableCell className="py-2">{fee.label}</TableCell>
        <TableCell className="py-2">{(fee.value / 100).toFixed(2)}%</TableCell>
        <TableCell className="py-2">{fee.type}</TableCell>
        <TableCell className="text-right py-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="icon" size="icon" aria-label="Open menu">
                <EllipsisVertical size={18} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuLabel>{fee.label}</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => setIsEditDialogOpen(true)}>
                <Pencil className="mr-2 h-4 w-4" />
                Edit Fee
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className="text-destructive"
                onClick={() => setIsDeleteDialogOpen(true)}
              >
                <Trash className="mr-2 h-4 w-4" />
                Delete Fee
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </TableCell>
      </TableRow>
      {isEditDialogOpen && (
        <EditFeeDialog fee={fee} setOpen={setIsEditDialogOpen} />
      )}
      {isDeleteDialogOpen && (
        <DeleteFeeDialog fee={fee} setOpen={setIsDeleteDialogOpen} />
      )}
    </>
  );
};

export default FeeRow;
